'use strict';

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _templateObject = _taggedTemplateLiteral(['\n&&& {\n  font-family: helvetica, arial, sans-serif;\n  font-size: 13px;\n  line-height: 18px;\n  background: #fafafa;\n  border: 1px solid #ddd;\n  color: #666;\n  border-radius: 3px\n}\n'], ['\n&&& {\n  font-family: helvetica, arial, sans-serif;\n  font-size: 13px;\n  line-height: 18px;\n  background: #fafafa;\n  border: 1px solid #ddd;\n  color: #666;\n  border-radius: 3px\n}\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n&&& {\n  position: relative;\n  border-bottom: 1px solid #ddd;\n  border-radius: 3px 3px 0 0;\n  background: #fcfcfc;\n  background: linear-gradient(#fcfcfc, #ebebeb);\n  & h3 {\n    word-wrap: break-word;\n    font-family: helvetica, arial, sans-serif;\n    font-weight: normal;\n    font-size: 16px;\n    color: gray;\n    margin: 0;\n    padding: 10px 10px 10px 30px;\n    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAXBAMAAAD0LQLXAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAASUExURQAAAL29vc3NzcLCwsjIyNbW1pvTNOEAAAABdFJOUwBA5thmAAAATElEQVQI12MIFoQAEQZFYwcGEGBkUDRUQLCcsYjRXhbqKkEGZQYGqJgSnKXCwGgsAGYpqyobG4WGhioyhBhDgClI3EQAqpaZwQBEAQARmA4G2o55nQAAAABJRU5ErkJggg==) 7px center no-repeat;\n    width: auto;\n  }\n  @media (max-width: 767px) {\n    height: auto;\n    min-height: 60px;\n  }\n}\n'], ['\n&&& {\n  position: relative;\n  border-bottom: 1px solid #ddd;\n  border-radius: 3px 3px 0 0;\n  background: #fcfcfc;\n  background: linear-gradient(#fcfcfc, #ebebeb);\n  & h3 {\n    word-wrap: break-word;\n    font-family: helvetica, arial, sans-serif;\n    font-weight: normal;\n    font-size: 16px;\n    color: gray;\n    margin: 0;\n    padding: 10px 10px 10px 30px;\n    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAXBAMAAAD0LQLXAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAASUExURQAAAL29vc3NzcLCwsjIyNbW1pvTNOEAAAABdFJOUwBA5thmAAAATElEQVQI12MIFoQAEQZFYwcGEGBkUDRUQLCcsYjRXhbqKkEGZQYGqJgSnKXCwGgsAGYpqyobG4WGhioyhBhDgClI3EQAqpaZwQBEAQARmA4G2o55nQAAAABJRU5ErkJggg==) 7px center no-repeat;\n    width: auto;\n  }\n  @media (max-width: 767px) {\n    height: auto;\n    min-height: 60px;\n  }\n}\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n&&& {\n  float: right;\n  position: absolute;\n  top: 8px;\n  right: 10px;\n  font-size: 11px;\n  font-weight: bold;\n  line-height: 21px;\n  height: auto;\n  min-height: 21px\n}\n'], ['\n&&& {\n  float: right;\n  position: absolute;\n  top: 8px;\n  right: 10px;\n  font-size: 11px;\n  font-weight: bold;\n  line-height: 21px;\n  height: auto;\n  min-height: 21px\n}\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n&&& {\n  color: #4183c4;\n  border: 0;\n  text-decoration: none;\n}\n'], ['\n&&& {\n  color: #4183c4;\n  border: 0;\n  text-decoration: none;\n}\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n&&& {\n  font-weight: bold;\n  @media (max-width: 767px) {\n    display: block;\n  }\n}\n'], ['\n&&& {\n  font-weight: bold;\n  @media (max-width: 767px) {\n    display: block;\n  }\n}\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n&&& {\n  display: inline-block;\n  height: 21px;\n  color: #666;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  padding: 0 5px 0 18px;\n  background: white url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAqBAMAAABB12bjAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAYUExURf///5mZmdbW1u/v7/r6+rGxscXFxaSkpHLccIMAAABsSURBVBjTY2CgBmBODTOAsFgSi9TFHMBMc1Fmk8BiEItJUMhQWFFQAZXJoC7q7FJYhNBmgG7YQAIWMYTvEExXIbh8oAJWQQe4IGsIlKmowAZVwaKowgxlMgkKmwtCjRAUYBSEqnVkYBAm39EALMwNXwql3eYAAAAASUVORK5CYII=) no-repeat;\n  @media (max-width: 767px) {\n    display: block;\n    clear: right;\n    float: right;\n  }\n}\n'], ['\n&&& {\n  display: inline-block;\n  height: 21px;\n  color: #666;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  padding: 0 5px 0 18px;\n  background: white url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAqBAMAAABB12bjAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAYUExURf///5mZmdbW1u/v7/r6+rGxscXFxaSkpHLccIMAAABsSURBVBjTY2CgBmBODTOAsFgSi9TFHMBMc1Fmk8BiEItJUMhQWFFQAZXJoC7q7FJYhNBmgG7YQAIWMYTvEExXIbh8oAJWQQe4IGsIlKmowAZVwaKowgxlMgkKmwtCjRAUYBSEqnVkYBAm39EALMwNXwql3eYAAAAASUVORK5CYII=) no-repeat;\n  @media (max-width: 767px) {\n    display: block;\n    clear: right;\n    float: right;\n  }\n}\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n&&& {\n  border-right: 1px solid #ddd;\n}\n'], ['\n&&& {\n  border-right: 1px solid #ddd;\n}\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n&&& {\n  background-position: -4px -21px;\n  padding-left: 15px\n}\n'], ['\n&&& {\n  background-position: -4px -21px;\n  padding-left: 15px\n}\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n&&& {\n  padding: 10px;\n  font-weight: 300;\n  & > p {\n    margin: 0;\n  }\n}\n'], ['\n&&& {\n  padding: 10px;\n  font-weight: 300;\n  & > p {\n    margin: 0;\n  }\n}\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n&&& {\n  font-weight: bold;\n}\n'], ['\n&&& {\n  font-weight: bold;\n}\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n&&& {\n  position: relative;\n  border-top: 1px solid #ddd;\n  background: white;\n  border-radius: 0 0 3px 3px;\n  padding: 10px;\n  height: auto;\n  min-height: 24px;\n  @media (max-width: 767px) {\n    height: auto;\n    min-height: 46px;\n  }\n}\n'], ['\n&&& {\n  position: relative;\n  border-top: 1px solid #ddd;\n  background: white;\n  border-radius: 0 0 3px 3px;\n  padding: 10px;\n  height: auto;\n  min-height: 24px;\n  @media (max-width: 767px) {\n    height: auto;\n    min-height: 46px;\n  }\n}\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n&&& {\n  word-wrap: break-word;\n  margin: 0;\n  font-size: 11px;\n  color: #666;\n  line-height: 24px;\n  font-weight: 300;\n  width: auto;\n  & strong {\n    font-weight: bold;\n    color: #000;\n  }\n}\n'], ['\n&&& {\n  word-wrap: break-word;\n  margin: 0;\n  font-size: 11px;\n  color: #666;\n  line-height: 24px;\n  font-weight: 300;\n  width: auto;\n  & strong {\n    font-weight: bold;\n    color: #000;\n  }\n}\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n&&& {\n  float: right;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  height: 24px;\n  line-height: 24px;\n  font-size: 12px;\n  color: #666;\n  font-weight: bold;\n  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.9);\n  text-decoration: none;\n  padding: 0 10px;\n  border: 1px solid #ddd;\n  border-bottom-color: #bbb;\n  border-radius: 3px;\n  background: #f5f5f5;\n  background: linear-gradient(#f5f5f5, #e5e5e5);\n  cursor: pointer;\n  &:hover {\n    color: #527894;\n    border-color: #cfe3ed;\n    border-bottom-color: #9fc7db;\n    background: #f1f7fa;\n    background: linear-gradient(#f1f7fa, #dbeaf1);\n  }\n}\n'], ['\n&&& {\n  float: right;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  height: 24px;\n  line-height: 24px;\n  font-size: 12px;\n  color: #666;\n  font-weight: bold;\n  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.9);\n  text-decoration: none;\n  padding: 0 10px;\n  border: 1px solid #ddd;\n  border-bottom-color: #bbb;\n  border-radius: 3px;\n  background: #f5f5f5;\n  background: linear-gradient(#f5f5f5, #e5e5e5);\n  cursor: pointer;\n  &:hover {\n    color: #527894;\n    border-color: #cfe3ed;\n    border-bottom-color: #9fc7db;\n    background: #f1f7fa;\n    background: linear-gradient(#f1f7fa, #dbeaf1);\n  }\n}\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FetchGithubRepo = require('./FetchGithubRepo');

var _FetchGithubRepo2 = _interopRequireDefault(_FetchGithubRepo);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // eslint-disable-line


var GithubBox = _styledComponents2["default"].div(_templateObject);

var GitHubTitle = _styledComponents2["default"].div(_templateObject2);

var GitHubStats = _styledComponents2["default"].div(_templateObject3);

var Link = _styledComponents2["default"].a.attrs({
  target: '_blank',
  rel: 'noreferrer noopener'
})(_templateObject4);

var RepoLink = Link.extend(_templateObject5);
var StatsLink = Link.extend(_templateObject6);
var WatchersLink = StatsLink.extend(_templateObject7);
var ForkersLink = StatsLink.extend(_templateObject8);

var GitHubContent = _styledComponents2["default"].div(_templateObject9);

var GitHubContentLink = _styledComponents2["default"].p(_templateObject10);

var Download = _styledComponents2["default"].div(_templateObject11);

var Updated = _styledComponents2["default"].div(_templateObject12);

var DownloadButton = _styledComponents2["default"].a(_templateObject13);

var GitHubWidget = function (_React$Component) {
  _inherits(GitHubWidget, _React$Component);

  function GitHubWidget(props) {
    _classCallCheck(this, GitHubWidget);

    var _this = _possibleConstructorReturn(this, (GitHubWidget.__proto__ || Object.getPrototypeOf(GitHubWidget)).call(this, props));

    var repo = {
      watchers: '?',
      forks: '?'
    }; // Allow preloading data.

    if (_this.props.data) {
      repo = _this.props.data;
    }

    _this.state = {
      repo: repo
    };
    return _this;
  }

  _createClass(GitHubWidget, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          data = _props.data,
          onDataFetched = _props.onDataFetched;

      if (data) {
        return Promise.resolve();
      }

      return (0, _FetchGithubRepo2["default"])(this.props.repository).then(function (repo) {
        _this2.setState({
          repo: repo
        });

        typeof onDataFetched === 'function' && onDataFetched(repo); // eslint-disable-line no-unused-expressions

        return repo;
      })["catch"](function (error) {
        console.error(error); // eslint-disable-line no-console
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var repository = this.props.repository;
      var repo = this.state.repo;

      var _repository$split = repository.split('/'),
          _repository$split2 = _slicedToArray(_repository$split, 2),
          vendorName = _repository$split2[0],
          repoName = _repository$split2[1];

      var vendorUrl = 'http://github.com/' + vendorName;
      var repoUrl = 'http://github.com/' + vendorName + '/' + repoName;
      return _react2["default"].createElement(GithubBox, null, _react2["default"].createElement(GitHubTitle, {
        className: 'github-box-title'
      }, _react2["default"].createElement('h3', null, _react2["default"].createElement(Link, {
        href: vendorUrl,
        title: vendorUrl
      }, vendorName), '/', _react2["default"].createElement(RepoLink, {
        href: repoUrl,
        title: repoUrl
      }, repoName)), _react2["default"].createElement(GitHubStats, null, _react2["default"].createElement(WatchersLink, {
        href: repoUrl + '/watchers',
        title: 'See watchers'
      }, repo.watchers), _react2["default"].createElement(ForkersLink, {
        href: repoUrl + '/network/members',
        title: 'See forkers'
      }, repo.forks))), _react2["default"].createElement(GitHubContent, null, _react2["default"].createElement('p', {
        className: 'description'
      }, _react2["default"].createElement('span', null, repo.description), " \u2014 ", _react2["default"].createElement(Link, {
        href: repoUrl + '#readme'
      }, 'Read More')), repo.homepage && _react2["default"].createElement(GitHubContentLink, null, _react2["default"].createElement(Link, {
        href: repo.homepage
      }, repo.homepage))), _react2["default"].createElement(Download, null, repo.pushed_at && _react2["default"].createElement(Updated, null, 'Latest commit to the', ' ', _react2["default"].createElement('strong', null, repo.default_branch), ' branch on ', repo.pushed_at.substring(0, 10)), _react2["default"].createElement(DownloadButton, {
        href: repoUrl + '/zipball/master',
        title: 'Get repository'
      }, 'Download as zip')));
    }
  }]);

  return GitHubWidget;
}(_react2["default"].Component);

GitHubWidget.propTypes = {
  /** The GitHub repository to display information about in "username/project" format. */
  repository: _propTypes2["default"].string.isRequired,

  /** Use this to load the repository data externally. */
  data: _propTypes2["default"].shape({
    watchers: _propTypes2["default"].number,
    forks: _propTypes2["default"].number,
    homepage: _propTypes2["default"].string,
    description: _propTypes2["default"].string,
    pushed_at: _propTypes2["default"].string
  }),

  /** Called with the response from GitHub. */
  onDataFetched: _propTypes2["default"].func
};
GitHubWidget.defaultProps = {
  data: undefined,
  onDataFetched: undefined
};
exports["default"] = GitHubWidget;
module.exports = exports['default'];